"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cachedSessionStore = void 0;
exports.clearCachedSession = clearCachedSession;
/**
 * In memory store for the cached session and fetch promise
 * - Set after successful fetch of session and if useSession
 * hook is called with a new session
 * - Cleared on `signOut` - assuming that `signIn` is not
 * called with a new user without calling `signOut` first
 */
exports.cachedSessionStore = {
    cachedSession: null,
    fetchPromise: null,
};
/**
 * Clears the cached session and fetch promise
 */
function clearCachedSession() {
    exports.cachedSessionStore.cachedSession = null;
    exports.cachedSessionStore.fetchPromise = null;
}
